/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { OptionalArgumentManager } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/argument/OptionalArgumentManager";
import { AbPopupContext } from "abreact/incubator/ui/popup/PopupContext";
import { AbCheckbox } from "abreact/input/AbCheckbox";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbPopupButton } from "abreact/misc/AbPopupButton";
import React from "react";

/**
 * A UX element that allows users to select optional arguments to display and hide.
 * Should be a descendant of OptionalArgumentManager.
 */
export function OptionalArgumentOperandSelector(props) {
  const context = React.useContext(OptionalArgumentManager.Context);
  const onChange = React.useCallback((identifier, popupContext) => {
    return value => {
      if (value) {
        context.showArgument(identifier);
      } else {
        context.hideArgument(identifier);
      }
      popupContext?.popupHandle.close();
    };
  }, [context]);
  const checkboxes = props.argumentOperands.filter(arg => arg.isOptional && arg.elementInfos.length > 0).map(arg => {
    const label = arg.expArgumentOperandGroup ? arg.expArgumentOperandGroup.selectorLabel : arg.expArgumentOperands[0].selectorLabel ?? arg.expArgumentOperands[0].label;
    return /*#__PURE__*/React.createElement(AbPopupContext.Consumer, {
      key: arg.argumentIdentifier
    }, popupContext => /*#__PURE__*/React.createElement(AbCheckbox, {
      label: label,
      dataTestId: `${props.dataTestIdPrefix}-opt-args-${arg.argumentIdentifier}`,
      value: context.shownOptionalArgumentIdentifiers.has(arg.argumentIdentifier),
      onChange: onChange(arg.argumentIdentifier, popupContext)
    }));
  });
  if (checkboxes.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const label = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, AbReactResources.expressionEditor_optionalArguments()), /*#__PURE__*/React.createElement(AbIcon, {
    image: "absdk:chevron-down"
  }));
  return /*#__PURE__*/React.createElement(AbPopupButton, {
    label: label,
    className: "ab-no-border-button ab-gee-optional-args-button",
    dataTestId: `${props.dataTestIdPrefix}-opt-args-button`,
    popupProps: {
      className: "ab-gee-optional-args-popup",
      dataTestId: `${props.dataTestIdPrefix}-opt-args-popup`
    },
    popupContents: /*#__PURE__*/React.createElement(AbVBox, {
      spacing: true
    }, checkboxes)
  });
}
//# sourceMappingURL=OptionalArgumentOperandSelector.js.map
